import { FC } from "react";
import { Theme } from "react-migration/lib/theme/Theme";
import { DeprecatedTooltip } from "react-migration/components/DeprecatedTooltip";

import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { Button } from "react-migration/components/Button";

export interface CalculatorButtonProps {
  openCalculator: () => void;
  hasLicense: boolean;
}

export const CalculatorButton: FC<CalculatorButtonProps> = ({ openCalculator, hasLicense }) => {
  const { t } = useTranslation();

  const openCalc = () => {
    openCalculator();
  };

  return (
    <div className="mt-1 flex flex-col items-center" data-testid="open-button">
      {!hasLicense && (
        <DeprecatedTooltip
          theme={Theme.Dark}
          placement="top"
          description={t("comparables.map.sidebar.filters.calculator.tooltip")}
          className="flex flex-col align-middle"
        >
          <Button disabled={true}>
            <i className="icon-lt-calculator-line mr-1" />
            {t("comparables.map.sidebar.filters.calculator")}
          </Button>
        </DeprecatedTooltip>
      )}
      {hasLicense && (
        <Button onClick={openCalc} data-testid="comparables-calculator">
          <span className="text-xs md:text-sm">
            <i className="icon-lt-calculator-line mr-1" />
            {t("comparables.map.sidebar.filters.calculator")}
          </span>
        </Button>
      )}
    </div>
  );
};
